import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hybse-admin-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.css']
})
export class IssuerEditUserComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-KYC-Admin/src/app/components/pages/users/issuers/edit-user/edit-user.component.ts